import { render } from "./ProjectSpectrum.vue?vue&type=template&id=4cfd682e"
import script from "./ProjectSpectrum.vue?vue&type=script&lang=js"
export * from "./ProjectSpectrum.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__